import ShareBtn from "./shareBtn";
import React, { useEffect, useRef, useState } from "react";

import ArrowRight from "images/icons/arrow-right.inline.svg";
import TimeCircleSvg from "images/icons/time-circle.inline.svg";

import Image from "../../components/image";
import { useTheme } from "../../context/ThemeContext";
import { useProgramFees } from "../../hooks/useProgramFees";
import { useProgramTitles } from "../../hooks/useProgramTitles";
import { Link } from "../../utils/customLink";
import { shortcodePreProcessor } from "../../utils/formatContent";
import { renderCurrencyDateImage } from "../../utils/formatContent";

const EnquireCard = ({
  applyNow,
  enquireNow,
  isMobile = false,
  cardStyle = "",
  cardDefaultWidth = "sm:w-[355px]",
  enquireCardDetails = {},
  applyCTALabel = "Apply",
  enquireCTALabel = "Enquire",
  isGVI = true,
  descClass = "mb-4 text-xl planet:text-[19px] planet:sm:text-xl font-normal planet:font-bold planet:sm:font-semibold text-left text-generic-text hover:text-gray-900 font-alice planet:font-body !leading-6",
  programPrice = ""
}) => {
  const { localeLanguage, currentSiteMeta, currentBrand } = useTheme();
  const [shareUrl, setShareUrl] = useState();

  const dateStrFormat = "";

  const {
    cardTitle,
    enquireCardImg,
    cardDesc,
    cardBookDesc,
    shareButton = true
  } = enquireCardDetails;

  const shareBtnRef = useRef();

  useEffect(() => {
    // eslint-disable-next-line no-restricted-globals
    setShareUrl(encodeURI(location?.href ?? "#"));
  }, []);

  const programFees = useProgramFees() || [];
  const programSubtitles = useProgramTitles() || "";

  const datesCostSubtitle = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: programSubtitles?.datesCostsSubtitle
  });

  const formattedCardDesc = shortcodePreProcessor({
    programFees,
    currentSiteMeta,
    description: cardDesc
  });

  const showPricingExtra = false;

  const gaEventButtonClick = (e) => {
    typeof window !== "undefined" &&
      window?.dataLayer?.push({
        event: "sidebar_enquire_card",
        event_category: "button_click",
        event_label: e.target.id
      });
  };

  return (
    <div
      className={`max-w-sm w-full relative ${
        isMobile ? "hidden" : ""
      } ${cardDefaultWidth} ${cardStyle}`}
    >
      <div className="relative transition duration-500 sm:shadow-lg hover:shadow-xl sm:border-gray-testimonial rounded-xs sm:rounded-xs border-0 sm:border-0.5">
        <div className="relative flex items-center w-full overflow-hidden h-44 rounded-xs sm:rounded-br-none sm:rounded-bl-none">
          {enquireCardImg && (
            <Image
              imageAlt=""
              image={""}
              imageClass="object-cover object-center w-full rounded-xs sm:rounded-br-none sm:rounded-bl-none"
              sourceUrl={enquireCardImg}
            />
          )}
          {cardTitle && (
            <div
              className="px-8 h1 font-normal text-left !text-white font-alice planet:sm:font-semibold planet:font-body leading-10"
              dangerouslySetInnerHTML={{ __html: cardTitle }}
            />
          )}
        </div>

        <div
          className={`px-1 sm:px-6 py-4 bg-primary-bg planet:sm:bg-[#3d3d3d]`}
        >
          {cardDesc && (
            <div
              className={`${descClass} planet:text-white ${isGVI ? "" : ""} `}
              dangerouslySetInnerHTML={{
                __html: `${formattedCardDesc} <span class="font-semibold ${isGVI ? "planet:text-gray-dark" : ""}">${
                  programPrice
                    ? [isGVI ? "From" : "", programPrice].join("&nbsp;")
                    : ""
                }</span>`
              }}
            />
          )}

          {showPricingExtra ? (
            <div className="w-full bg-gray-lighten planet:bg-gray-standard rounded-full flex py-2 items-center justify-center gap-2 my-5">
              <Image
                imageAlt={""}
                image={""}
                imageClass="inline-block w-5"
                sourceUrl={renderCurrencyDateImage({
                  currentSiteMeta,
                  currentBrand
                })}
              />
              <div
                className="desc font-body text-xs planet:text-white text-generic-text"
                dangerouslySetInnerHTML={{ __html: datesCostSubtitle }}
              />
            </div>
          ) : (
            <>
              {isGVI && (
                <div className="flex items-center gap-2 space-between">
                  {cardBookDesc && (
                    <div className="flex items-center justify-center w-full px-3 py-3 rounded-full sm:py-2 bg-gray-lighten planet:bg-gray-standard">
                      <TimeCircleSvg className="w-6 h-6 planet:sm:w-5 planet:sm:h-5 planet:gvi-text-green text-tertiary-bg fill-yellow-lighten planet:fill-green-standard" />
                      <span
                        className="pl-2 text-xs font-semibold text-left sm:font-normal planet:text-white text-generic-text"
                        dangerouslySetInnerHTML={{
                          __html: `${cardBookDesc} ${dateStrFormat}`
                        }}
                      />
                    </div>
                  )}
                  {shareButton === true ? (
                    <div
                      className={`${
                        cardDesc ? "" : "w-full "
                      }flex items-center justify-center px-3 py-3 rounded-full sm:py-2 bg-gray-lighten planet:bg-gray-dark cursor-pointer hover:planet:color-white hover:color-black-lighter opacity-60 hover:opacity-100`}
                      onClick={() => shareBtnRef.current.handleClick()}
                    >
                      <ShareBtn url={shareUrl} ref={shareBtnRef} />
                      <span className="pl-2 text-xs font-semibold text-left sm:font-normal planet:text-white text-generic-text ">
                        Share
                      </span>
                    </div>
                  ) : null}
                </div>
              )}
            </>
          )}
        </div>

        <div
          className={`flex rounded-full sm:rounded-t-none sm:rounded-b-xs bg-yellow-standard planet:bg-gray-standard ${
            (enquireNow || applyNow) && "sm:h-16"
          }`}
        >
          {enquireNow && (
            <Link
              className="flex items-center justify-center w-full h-16 max-w-sm py-4 font-bold text-white sm:flex"
              to={enquireNow}
              onClick={gaEventButtonClick}
              id="enquire"
            >
              <div className="items-center justify-center">
                <div>
                  <div className="flex items-center gap-2 sm:grid sm:grid-cols-9">
                    <div
                      className="col-span-1 sm:col-span-7 sm:col-start-2"
                      dangerouslySetInnerHTML={{
                        __html: ["us", "can"].includes(localeLanguage)
                          ? "Find out more"
                          : enquireCTALabel
                      }}
                    />

                    <div className="col-span-1 sm:col-start-10">
                      <ArrowRight className="stroke-white" />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          )}

          {applyNow && (
            <Link
              className="flex items-center justify-center w-full h-auto py-2 font-bold text-white rounded-full sm:h-16 sm:py-4 sm:rounded-none sm:rounded-br-xs bg-red-light planet:gvi-bg-green planet:text-gray-darker"
              to={applyNow}
              onClick={gaEventButtonClick}
              id="apply"
            >
              <div className="flex items-center justify-center">
                <div className="">
                  <div className="flex items-center gap-2 sm:grid sm:grid-cols-9">
                    <div
                      className="col-span-1 sm:col-span-7 sm:col-start-2"
                      dangerouslySetInnerHTML={{ __html: applyCTALabel }}
                    />
                    <div className="col-span-1 sm:col-start-10">
                      <ArrowRight className=" stroke-white planet:stroke-gray-darker" />
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          )}
        </div>
        {/* )} */}
      </div>
    </div>
  );
};

export default EnquireCard;
